module.exports = __webpack_public_path__ + "img/vue-logo.c2a605fb.png";